var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5111 27.7444C32.7257 25.81 30.5591 24.2662 28.1477 23.2104C25.7363 22.1545 23.1324 21.6094 20.5 21.6094C17.8676 21.6094 15.2637 22.1545 12.8523 23.2104C10.4409 24.2662 8.27427 25.81 6.48888 27.7444C6.21323 28.0492 6.05903 28.4446 6.05554 28.8555V35.5222C6.06138 35.9604 6.23956 36.3786 6.55148 36.6864C6.86341 36.9942 7.284 37.1667 7.72221 37.1667H33.2778C33.7198 37.1667 34.1437 36.9911 34.4563 36.6785C34.7688 36.3659 34.9444 35.942 34.9444 35.5V28.8333C34.9356 28.4301 34.7817 28.0435 34.5111 27.7444Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 19.3889C24.7956 19.3889 28.2778 15.9066 28.2778 11.6111C28.2778 7.31554 24.7956 3.83331 20.5 3.83331C16.2045 3.83331 12.7222 7.31554 12.7222 11.6111C12.7222 15.9066 16.2045 19.3889 20.5 19.3889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/user.icon.09afee337987f49a83b72bb66a3cf899.svg";
export { ForwardRef as ReactComponent };